<script>
import { mapGetters } from 'vuex'
import { templateFileDownloader } from '@/helpers/templateFileDownloader'
import Avv from '@/components/common/Avv.vue'
import Upload from '@/components/upload/Upload.vue'
import OrdersSelectScheduled from '@/components/orders/OrdersSelectScheduled.vue'
export default {
  components: {
    Upload,
    Avv,
    OrdersSelectScheduled
  },
  mixins: [templateFileDownloader],
  props: {
    nextStep: { type: Function }
  },
  data: () => ({
    singleFiles: [],
    serialFiles: [],
    metaDataLoading: {
      single: false,
      series: false
    },
    docxDownloaded: false,
    creatingOrder: false,
    acceptAvv: true,
    scheduledOrder: { id: null, checked: false }
  }),
  computed: {
    ...mapGetters(['hasAVV']),
    singleErrorFiles() {
      return this.singleFiles.filter(
        file => file.fileUploadStatus === this.$enums.FileUploadStatus.Failed
      )
    },
    serialErrorFiles() {
      return this.serialFiles.filter(
        file => file.fileUploadStatus === this.$enums.FileUploadStatus.Failed
      )
    },
    disabledCreateOrder() {
      return (
        (this.singleFiles.length <= 0 && this.serialFiles.length <= 0) ||
        (!this.hasAVV && !this.acceptAvv) ||
        this.metaDataLoading.single ||
        this.metaDataLoading.series ||
        (this.scheduledOrder.checked && !this.scheduledOrder.id) ||
        this.singleErrorFiles.length > 0 ||
        this.serialErrorFiles.length > 0
      )
    }
  },
  methods: {
    handleUpdateFiles(event, category) {
      if (event.length > 0) {
        this.metaDataLoading[category] =
          event.filter(
            file =>
              file.fileUploadStatus === this.$enums.FileUploadStatus.Pending
          ).length > 0
      }
    },
    getUploadedFileIds() {
      let fileIds = []
      // add fileIds into array
      fileIds = fileIds.concat(this.singleFiles.map(a => a.id))
      fileIds = fileIds.concat(this.serialFiles.map(a => a.id))
      return fileIds
    },
    submitFiles() {
      this.creatingOrder = true
      // normal user has not accepted avv yet
      if (!this.hasAVV) {
        this.$refs.Avv.submitAVV()
          .then(() => {
            this.createOrder()
          })
          .catch(() => {
            this.creatingOrder = false
          })
      } else {
        if (this.scheduledOrder.checked) this.updateOrder()
        else this.createOrder()
      }
    },
    createOrder() {
      this.$ordersService
        .createOrder(this.getUploadedFileIds())
        .then(orderResponse => {
          this.nextStep({ originStep: 1, response: orderResponse })
        })
        .catch(() => {
          this.$notify(this.$t('component.upload.wrapper.serviceNotAvailable'), {
            type: 'error'
          })
        })
        .finally(() => {
          this.creatingOrder = false
        })
    },
    updateOrder() {
      this.$ordersService
        .updateOrder({
          orderId: this.scheduledOrder.id,
          fileIds: this.getUploadedFileIds()
        })
        .then(orderResponse => {
          this.nextStep({ originStep: 1, response: orderResponse })
        })
        .catch(() => {
          this.$notify(this.$t('component.upload.wrapper.serviceNotAvailable'), {
            type: 'error'
          })
        })
        .finally(() => {
          this.creatingOrder = false
        })
    },
    getDownloadBtnText() {
      return this.$vuetify.breakpoint.smAndUp
        ? this.$t('button.download.letter.template')
        : this.$t('button.letter.template')
    }
  }
}
</script>
<template>
  <div>
    <v-card>
      <v-card-text class="pa-0">
        <v-row>
          <v-col cols="12" md="6">
            <Upload
              :letter-category="'single'"
              :files.sync="singleFiles"
              :loading="metaDataLoading.single"
              @update:files="handleUpdateFiles($event, 'single')"
            />
          </v-col>
          <v-col cols="12" md="6">
            <Upload
              :letter-category="'series'"
              :files.sync="serialFiles"
              :loading="metaDataLoading.series"
              @update:files="handleUpdateFiles($event, 'series')"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row justify="space-between" class="pa-0 ma-0" align="end">
          <v-col cols="12" sm="auto" class="pa-sm-0 ma-0">
            <a @click="downloadDocx()"
            ><v-icon>mdi-file-document-outline</v-icon>
              {{ getDownloadBtnText() }}</a
            ><br />
            <span
              v-if="docxDownloaded"
              class="docx-info justify-center secondary--text">
              <v-icon>mdi-information-outline</v-icon>
              {{ $t('component.upload.wrapper.letterTemplateInfo') }} </span>
            <Avv
            ref="Avv"
            :set-avv-checkbox.sync="acceptAvv"
            hide-title
            hide-submit />
          </v-col>
          <v-col cols="12" sm="auto" class="pa-sm-0 ma-0">
            <OrdersSelectScheduled
              v-if="$permissions.hasOrderAutocomplete"
              v-model="scheduledOrder" />
            <v-btn
              id="checkDocuments"
              block
              class="text-center pa-3 tertiary"
              :loading="creatingOrder"
              :disabled="disabledCreateOrder"
              @click="submitFiles()">
              {{ $t('button.next') }}
              <v-icon right>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>
<style lang="scss" scoped>
.avv_checkbox {
  .v-input--selection-controls__input {
    position: absolute;
    top: 0;
  }
}
.docx-btn {
  font-size: 13px;
}
.docx-info {
  font-size: 12px;
  text-align: center;
}
.expand-transition-enter-active,
.expand-transition-enter-to,
.expand-transition-leave-active,
.expand-transition-leave-to {
  transition: all 0.75s !important;
}
</style>
